window.VariationsWidget ?= {}
VariationsWidget.Views ?= {}

VariationsWidget.Views.Option = Backbone.View.extend
  initialize: ->
    _.bindAll this, 'render'
    @model.bind 'change:disabled', @render

    if VariationsWidget.printSoldOut
      @model.bind 'change:forceDisplay', @render
    if VariationsWidget.printOptionPrice
      @model.bind 'change:optionPrice', @render
      @model.bind 'change:selected', @render

    @rtl = $('body').hasClass('rtl')

  render: ->
    @$el.attr 'disabled', @model.get('disabled')

    if VariationsWidget.printSoldOut
      @renderSoldOut()
    if VariationsWidget.printOptionPrice
      @renderPrintOptionPrice()

  renderSoldOut: ->
    soldOutText = I18n?.t('js.modules.variations.sold_out')
    string = "<span class=\"sold-out-text\">#{soldOutText}</span>"
    @$el.removeClass('force-display')
    @$el.find('.sold-out-text').remove()

    if @model.get('forceDisplay')
      @$el.addClass('force-display')
      if @rtl then @$el.append(string) else @$el.prepend(string)

  renderPrintOptionPrice: ->
    optionPrice = @model.get('optionPrice')
    isSelected = @model.get('selected')
    string = "<span class=\"option-price\">(#{optionPrice})</span>"
    @$el.find('.option-price').remove()

    if optionPrice and not isSelected
      if @rtl then @$el.prepend(string) else @$el.append(string)

module.exports = VariationsWidget.Views.Option
